import React, {Component} from 'react'
import 'url-search-params-polyfill'
import './App.css'
import Wall from './components/walls/Wall'
import Home from './components/Home'
import Gym from './components/gyms/Gym'
import Gyms from './components/gyms/Gyms'
import Users from './components/users/Users'
import EditWall from './components/walls/EditWall'
import {Switch, Route, BrowserRouter} from 'react-router-dom'
import * as GymHelpers from './helpers/gymHelpers'
import MomentUtils from '@date-io/moment'
import {MuiPickersUtilsProvider} from '@material-ui/pickers'
import {withStyles, MuiThemeProvider} from '@material-ui/core/styles'
import theme from './Theme'
import {styles, mobileTheme} from './Theme'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {SnackbarProvider} from 'notistack'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gyms: [],
      problems: [],
      loading: true,
    }
  }
  componentDidMount() {
    this.registerListeners()
  }

  registerListeners = () => {
    let collectionRef = window.firebaseDb.collection('gyms')
    let data = []

    collectionRef.onSnapshot(collectionSnapshot => {
      if (!collectionSnapshot.docs.length) {
        return data
      } else {
        data = collectionSnapshot.docs.map(function (documentSnapshot) {
          return Object.assign({}, documentSnapshot.data(), {
            key: documentSnapshot.id,
          })
        })
        this.setState({
          gyms: data,
          loading: false,
        })
      }
    })

    collectionRef = window.firebaseDb.collection('problems')

    collectionRef.onSnapshot(collectionSnapshot => {
      if (!collectionSnapshot.docs.length) {
        return data
      } else {
        data = collectionSnapshot.docs.map(d => {
          return Object.assign({}, d.data(), {key: d.id})
        })
        this.setState({
          problems: data,
        })
      }
    })
    console.info('finished registering listeners')
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route
            exact
            path="/gyms"
            render={props => {
              return <Gyms {...props} gyms={this.state.gyms} />
            }}
          />
          <Route
            exact
            path="/gyms/:gymName"
            render={props => {
              console.info(props)
              let gymId = props.match.params.gymName
              console.info('GYMID: ' + gymId)
              let gym
              this.state.gyms.forEach(g => {
                if (g.id === gymId) {
                  gym = Object.assign({}, g)
                  // TODO: Nate: avoid forEach so we can break out of loop
                  // break
                }
              })
              let problems = this.state.problems.filter(p => p.gymId === gymId)
              return <Gym {...props} gym={gym} problems={problems} />
            }}
          />
          <Route exact path="/gyms/:gymName/walls" component={Gym} />
          <Route
            exact
            path="/gyms/:gymName/walls/:wallName"
            render={props => {
              let gymId = props.match.params.gymName
              let wallId = props.match.params.wallName
              let gym = this.state.gyms.filter(g => g.id === gymId)[0]
              let wall = gym && gym.walls[wallId]

              let problems = this.state.problems.filter(
                p => p.gymId === gymId && p.wallId === wallId,
              )
              return (
                <Wall {...props} gym={gym} wall={wall} problems={problems} />
              )
            }}
          />
          <Route
            exact
            path="/gyms/:gymName/walls/:wallName/problems/:problemKey"
            render={props => {
              let gymId = props.match.params.gymName
              let wallId = props.match.params.wallName
              let gym = this.state.gyms.filter(g => g.id === gymId)[0]
              let wall = gym && gym.walls[wallId]

              let problems = this.state.problems.filter(
                p => p.gymId === gymId && p.wallId === wallId,
              )
              let problemKey = props.match.params.problemKey
              let activeProblem =
                (problemKey && GymHelpers.findProblem(problemKey, problems)) ||
                undefined
              return (
                <Wall
                  {...props}
                  gym={gym}
                  wall={wall}
                  problems={problems}
                  activeProblem={activeProblem}
                  problemKey={problemKey}
                />
              )
            }}
          />
          <Route
            exact
            path="/gyms/:gymName/walls/:wallName/edit"
            render={props => {
              return <EditWall {...props} />
            }}
          />
          <Route
            exact
            path="/users"
            render={props => {
              return <Users {...props} />
            }}
          />
        </Switch>
      </BrowserRouter>
    )
  }
}

function wrappedApp(Component) {
  function testFunction(props) {
    const isDesktop = useMediaQuery('(min-device-width: 1250px)')
    const Styled = withStyles(styles)(Component)

    return (
      <MuiThemeProvider theme={isDesktop ? theme : mobileTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <App {...props} isDesktop={isDesktop}>
            <SnackbarProvider maxSnack={4}>
              <Styled isDesktop={isDesktop} />
            </SnackbarProvider>
          </App>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    )
  }
  return testFunction
}

export default wrappedApp(App)



// WEBPACK FOOTER //
// ./src/App.js